import {AdminRuntimeStorageKey} from '../constants/AdminRuntimeStorageKey'
import {DefaultAdminRuntimeState} from '../constants/DefaultAdminRuntimeState'
import {AdminRuntimeEnvProfile} from '../enum/AdminRuntimeEnvProfile'
import {IAdminRuntimeState} from '../types/IAdminRuntimeState'

export function readAdminRuntimeStateFromStorage(): IAdminRuntimeState {
  if(typeof localStorage === 'undefined') {
    return {
      ...DefaultAdminRuntimeState,
      overrides: {},
    }
  }
  try {
    const raw = localStorage.getItem(AdminRuntimeStorageKey)
    if(!raw) {
      return {
        ...DefaultAdminRuntimeState,
        overrides: {},
      }
    }
    const parsed = JSON.parse(raw) as Partial<IAdminRuntimeState>
    return {
      godMode: Boolean(parsed.godMode),
      profile: parsed.profile || AdminRuntimeEnvProfile.Inherit,
      overrides: parsed.overrides || {},
    }
  } catch {
    return {
      ...DefaultAdminRuntimeState,
      overrides: {},
    }
  }
}
